import React from 'react';
import { observer } from 'mobx-react-lite';

import Select from 'ati-ui-react/components/AtiSelect';

import { useStores } from 'hooks/useStores';
import setUrlParam from 'utils/setUrlParam';
import SearchParameter from '../SearchParameter/SearchParameter';
import typeTrucks from './typeTrucks';

const defaultOrdering = {
  label: 'Все типы транспорта',
  value: 'all_types_trucks',
};

const TypeOfTransport = observer(() => {
  const {
    findTrucksStore: {
      fields: { advert_item_type, ordering },
      updateSelect,
    },
  } = useStores();

  const renderTypeOfTrucks = () => {
    const allowSpecialMachinery = new Set([
      'bus',
      'truck',
      'tractor',
      'trailer',
      'semitrailer',
      'road_train',
    ]);
    const allowOtherMachinery = new Set([
      'truck_crane',
      'excavator',
      'dozer',
      'loader',
      'other_special',
    ]);

    const specialMachinery = typeTrucks.filter((item) => !allowSpecialMachinery.has(item.value));
    const otherMachinery = typeTrucks.filter((item) => !allowOtherMachinery.has(item.value));

    if (ordering === null) {
      return typeTrucks;
    }

    if (ordering === 'mileage') {
      return otherMachinery;
    }

    if (ordering === 'working_hours') {
      return specialMachinery;
    }

    return typeTrucks;
  };

  return (
    <SearchParameter caption="Tип транспорта" typeOfTransport>
      <Select
        placeholder="Например, грузовик"
        value={advert_item_type || defaultOrdering}
        options={renderTypeOfTrucks()}
        onChange={(value) => {
          updateSelect({ field: 'advert_item_type', value: value?.value });
          setUrlParam({ field: 'advert_item_type', value: value?.value });
        }}
        clearable={false}
        searchable={false}
      />
    </SearchParameter>
  );
});

export default TypeOfTransport;
